import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=2d25c368&scoped=true&"
import script from "./Invite.vue?vue&type=script&lang=ts&"
export * from "./Invite.vue?vue&type=script&lang=ts&"
import style0 from "./Invite.vue?vue&type=style&index=0&id=2d25c368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d25c368",
  null
  
)

export default component.exports